import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const SkipLink = styled.a`
  height: auto;
  min-height: 36px;
  top: 4px;
  font-size: 16px;

  position: fixed;
  z-index: 12;
  /* top: 1em; */
  left: 1em;
  padding: 0.5em;
  transform: translateY(-200%);
  transition: transform 150ms;
  /*  */
  display: inline-flex;
  justify-content: center;
  align-items: center;

  font-family: ${themeGet('fonts.primary')};
  font-weight: ${themeGet('font-weights.semi-bold')};
  text-align: center;
  border-radius: 4px;
  border: none;

  letter-spacing: -0.5px;
  line-height: 21px;

  min-width: 160px;

  padding: 0 22px;

  transition: all 500ms ease;

  border: 3px solid ${themeGet('colors.orange')};
  background-color: ${themeGet('colors.orange')};
  color: ${themeGet('colors.white')};

  &:hover,
  &:focus {
    border: 3px solid ${themeGet('colors.dark-orange')};
    background-color: ${themeGet('colors.dark-orange')};
  }

  &:focus,
  &:active {
    border: 3px solid ${themeGet('colors.darkest-orange')};
    background-color: ${themeGet('colors.darkest-orange')};
  }

  &:focus {
    transform: unset;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    top: 6px;
    font-size: 18px;
    min-height: 48px;
  }
`;
